import * as SessionRecordingService from './SessionRecordingService';

export function initializeSessionAnalyticsServices() {
  SessionRecordingService.initializeRecordingService();
}

export function event(...args) {
  console.debug(...args);
  SessionRecordingService.event(...args);
}

export function identify(...args) {
  SessionRecordingService.identify(...args);
}
